import { render, staticRenderFns } from "./PlayConfig.vue?vue&type=template&id=65b101ea&scoped=true&"
import script from "./PlayConfig.vue?vue&type=script&lang=js&"
export * from "./PlayConfig.vue?vue&type=script&lang=js&"
import style0 from "./PlayConfig.vue?vue&type=style&index=0&id=65b101ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b101ea",
  null
  
)

export default component.exports